import { ProductGroupSummary } from '@public-api-contracts/models/product/ProductGroupSummary';
import { translate } from './TranslationService';
import { ProductGroup } from '../models/ProductGroup';

export function transformCombinationsToProductGroups(
    groups: ProductGroupSummary[],
    options:
        | {
              withLink: true;
              combinationWithProductIds: string[];
          }
        | {
              withLink: false;
          }
): ProductGroup[] {
    const productGroups: ProductGroup[] = groups.map(g => ({
        products: g.products,
        title:
            g.categoryFilter.categoryTranslatedValue ??
            g.categoryFilter.categoryValue,
        ...(options.withLink &&
            g.totalQuantity > g.products.length && {
                subtitle: translate(
                    'PRODUCT_SEARCH_COMBINATIONS_CATEGORY_LINK'
                ),
                subtitleFeatureOptions: {
                    featureType: 'product-search-complementary-category',
                    combinationWithProductIds:
                        options.combinationWithProductIds,
                    categoryValue: g.categoryFilter.categoryValue,
                    categoryFilter: g.categoryFilter
                }
            }),
        totalQuantity: g.totalQuantity
    }));
    return productGroups;
}
